<template>
  <div>
    <v-card-title>{{ displayTitle }}</v-card-title>
    <v-card-text class="py-0 px-1">
      <v-row no-gutters>
        <v-col cols="12" sm="3">
          <div>
            <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
            <v-img
              :src="require('../../../../../public/controller.jpg')"
              max-width="300"
              contain
              class="image-controller mt-2"
            ></v-img>
          </div>
        </v-col>
        <v-col cols="12" sm="6" class="controller-info" :class="{ 'pl-8' : !isCheckSizeSmall }">
          <div class="information">
            <p><b>Информация о контроллере:</b></p>
            <p v-if="controller.doorphones[0]">
              <v-icon small class="pr-1">mdi-doorbell-video</v-icon>
              Привязанные домофоны:
              <template v-for="(tmp, index) of controller.doorphones">
                <router-link class="routerLink" v-bind:key="tmp.id" :to="`/controller/${tmp.id}`">
                  Домофон №{{ tmp.id }}
                </router-link>
                <template v-if="index !== controller.doorphones.length - 1">,</template>
              </template>
              .
            </p>
            <p v-if="controller.created_at">
              <v-icon small class="pr-1">mdi-calendar</v-icon>
              Дата установки: {{ ruDateFormat(controller.created_at) }}</p>
            <p v-if="controller.region_name">
              <v-icon small class="pr-1">mdi-map-marker-radius-outline</v-icon>
              Район: {{ controller.region_name }}</p>
            <p v-if="controller.address">
              <v-icon small class="pr-1">mdi-rename-box-outline</v-icon>
              Адрес: {{ controller.address }}</p>
            <p v-if="controller.name">
              <v-icon small class="pr-1">mdi-rename-outline</v-icon>
              Название в моб. приложении: {{ controller.name }}</p>
            <p v-if="controller.physical_status">
              <v-icon small class="pr-1">mdi-progress-clock</v-icon>
              Физический статус: {{ physicalStatus(controller.physical_status) }}</p>
            <p v-if="controller.agent">
              <v-icon small class="pr-1">mdi-account-search</v-icon>
              Агент: {{ controller.agent }}</p>
            <p>
              <v-icon small class="pr-1">mdi-progress-clock</v-icon>
              SIP статус:
              <v-icon x-small :color="controller.sip_status === '2' ? 'green' : 'red'">mdi-checkbox-blank-circle</v-icon>
              {{ getSipStatus(controller.sip_status) }}
              <v-btn
                v-if="$checkPermission('update_controller')"
                x-small
                color="primary"
                icon
                :loading="isUpdatedSip"
                @click.prevent="updateSipStatus()"
              >
                <v-icon small button color="primary">mdi-cached</v-icon>
              </v-btn>
            </p>
          </div>
        </v-col>
        <v-col cols="12" sm="3" class="pt-5 pr-4 action-container">
          <v-row class="action-column d-flex align-end flex-column">
            <v-btn
              v-if="$checkPermission('edit_controller')"
              color="#1E6CEB"
              dark
              small
              class="px-2 d-block"
              style="max-width: 160px; width: 100%; border-radius: 8px;"
              @click.prevent="editController(controller.id)"
            >
              Редактировать
            </v-btn>
            <v-btn
              v-if="$checkPermission('open_barrier')"
              color="success"
              dark
              small
              class="mt-3 px-2"
              style="max-width: 160px; width: 100%; border-radius: 8px; font-size: 11px"
              @click.prevent="openDeviceClick()"
            >
              Открыть дверь
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-row class="pa-5">
      <v-icon small>mdi-cog-outline</v-icon>
      <v-card-subtitle class="pl-1">
        Привязанные устройства
      </v-card-subtitle>
      <v-spacer></v-spacer>
      <v-btn
        v-if="disableRoleName"
        outlined
        class="text-none mt-3 px-2 btn-web-device"
        dark
        rounded
        style="max-width: 195px; width: 100%;"
        :href="transitionWebDevice"
        target="_blank"
        rel="noopener noreferrer"
      >
        Переход на web морду
      </v-btn>
    </v-row>
    <v-data-table
      class="table row-click"
      :headers="headersDevice"
      :items="[controller.device]"
      hide-default-footer
      :disable-sort="true"
      style="cursor: default;"
    >
      <template v-slot:item.updatedAt="{ item }">
        {{ ruDateFormat(item.updated_at) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="$checkPermission('view_device')"
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(DetailDialog, item.id, true)"
              >
                <v-icon>mdi-information-slab-circle-outline</v-icon>
              </v-btn>
              <v-dialog v-model="DetailDialog[item.id]" max-width="700">
                <DetailDeviceModal
                  :active.sync="DetailDialog[item.id]"
                  @close="$set(DetailDialog, item.id, false)"
                  :device="item"/>
              </v-dialog>
            </template>
            <span>Подробнее</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DetailDeviceModal from '../../../device/DetailDeviceModal';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import { headersDevice } from '../../consts';

export default {
  components: { DetailDeviceModal },
  mixins: [ruDateFormatMixin],
  name: 'GeneralInfo',
  props: ['id'],
  data () {
    return {
      headersDevice,
      DetailDialog: {},
      snapshot: null,
      loading: false,
      isMobile: false,
      disableRoleNameAdmin: false,
      videoLoader: true,
      disableRoleName: false,
      isCheckSizeSmall: false,
      isUpdatedSip: false,
    };
  },
  created () {
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
    switch (this.roleName) {
      case 'admin' : this.disableRoleNameAdmin = true;
        break;
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      controller: 'Controllers/controller',
      roleName: 'roleName',
    }),
    transitionWebDevice () {
      return `http://${this.controller.device.ip_address}.intercom.access.simdev.ru/`;
    },
    displayTitle () {
      return 'Контроллер';
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
  },
  methods: {
    ...mapActions({
      importSipStatus: 'Controllers/getSipStatus',
      getController: 'Controllers/getController',
      openDorController: 'Controllers/openDorController',
    }),
    getSipStatus (status) {
      switch (status) {
        case '2' : return '(Зарегестрировано)';
        default: return '(Не в сети)';
      }
    },
    openDeviceClick () {
      this.openDorController(this.$route.params.id)
        .then(() => {
          this.$flash_success('Открыто!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии');
        });
    },
    updateSipStatus () {
      this.isUpdatedSip = true;
      this.importSipStatus(this.$route.params.id)
        .then(() => {
          this.$flash_success('SIP статус обновился!');
          this.getController({
            id: this.$route.params.id,
          })
            .catch(() => {
              this.$flash_warning('Ошибка при загрузке информации');
            });
        })
        .catch(() => {
          this.$flash_warning('Не удолось обновить SIP статус');
        })
        .finally(() => {
          this.isUpdatedSip = false;
        });
    },
    checkSize () {
      this.isCheckSizeSmall = window.innerWidth <= 600;
    },
    physicalStatus (item) {
      switch (item) {
        case 1: return 'Установлен';
        case 2: return 'Не установлен';
        case 3: return 'Без интернет соединения';
        case 4: return 'Пусконаладка';
        case 5: return 'Старый домофон';
        default: return '';
      }
    },
    editController (id) {
      this.$router.push({ name: 'EditController', params: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: cornflowerblue;
}

a:hover.routerLink {
  text-decoration: underline;
}
.row-click {
  cursor: pointer;
}
.btn-web-device {
  border-radius: 20px;
  background-color: transparent;
  color: #1E6CEB;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.btn-web-device:hover {
  background-color: #1E6CEB;
  color: white;
}
.preloader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0,0,0, .2);
  }

  &-circular {
    z-index: 3;
  }
}
.image-barrier {
  cursor: pointer;
}
.action-list {
  border: 1px solid #1976d2;
  border-radius: 4px;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
}
.barrier-info, .barrier-info {
  color: rgba(0, 0, 0, 0.87);
}
.information p {
  margin-bottom: 4px;
}
.sip-history-header {
  position: sticky;
  top: 0;
  z-index: 999;
}
.action-container {
  text-align: -webkit-center;
}
.abonent-table-title {
  padding-top: 20px;
  padding-left: 30px;
}
@media screen and (max-width: 600px) {
  .action-column {
    display: inline-grid !important;
  }
  .barrier-info-one, .barrier-info-two {
    padding-left: 0;
    margin-left: 0;
  }
}
</style>
